var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChooseYourSide1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 923,
    height: 95,
    viewBox: "0 0 923 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.084 68H0L1 0H923L922 68H703.745C695.86 68 688.253 70.9107 682.383 76.1738L671.617 85.8262C665.747 91.0893 658.14 94 650.255 94H461H267.916C258.749 94 250.022 90.0685 243.948 83.2024L240.052 78.7976C233.978 71.9315 225.251 68 216.084 68Z",
    fill: "url(#paint0_linear_1_14)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 68H216.084C225.251 68 233.978 71.9315 240.052 78.7976L243.948 83.2024C250.022 90.0685 258.749 94 267.916 94H461H650.255C658.14 94 665.747 91.0893 671.617 85.8262L682.383 76.1738C688.253 70.9107 695.86 68 703.745 68H922",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_14",
    x1: 922,
    y1: 28.0057,
    x2: -0.00000144895,
    y2: 28.0056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385754,
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49724
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.611049,
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseYourSide1);
export default __webpack_public_path__ + "static/media/choose-your-side-1.c0aea0e00282ef8d2403f46769454eca.svg";
export { ForwardRef as ReactComponent };